import { useTranslation } from "react-i18next";
import { MotionReveal } from "./MotionReveal";

export function Comparison() {
  const { t } = useTranslation("global");
  const rows = t("comparison.rows", { returnObjects: true });

  return (
    <section className="siat-section" id="comparison">
      <div className="siat-wrap">
        <MotionReveal className="siat-intro siat-intro--wide">
          <p className="siat-eyebrow">{t("comparison.sideTitle")}</p>
          <h2>{t("comparison.title")}</h2>
        </MotionReveal>

        <MotionReveal className="siat-compare">
          <div className="siat-compare__col siat-compare__col--muted">
            <p className="siat-versus__label">{t("comparison.headers.cctv")}</p>
            <ul>
              {Array.isArray(rows) &&
                rows.map((row) => (
                  <li key={`c-${row.label}`}>
                    <strong>{row.label}</strong>
                    <span>{row.cctv}</span>
                  </li>
                ))}
            </ul>
          </div>
          <div className="siat-compare__col siat-compare__col--active">
            <p className="siat-versus__label siat-versus__label--gold">
              {t("comparison.headers.siat")}
            </p>
            <ul>
              {Array.isArray(rows) &&
                rows.map((row) => (
                  <li key={`s-${row.label}`}>
                    <strong>{row.label}</strong>
                    <span>{row.siat}</span>
                  </li>
                ))}
            </ul>
          </div>
        </MotionReveal>

        <MotionReveal as="p" className="siat-compare__closing" delay={0.1}>
          {t("comparison.closing")}
        </MotionReveal>
      </div>
    </section>
  );
}
